import type {FC} from "react";
import {useContext, memo} from "react";
import {MenuItem, MenuList, MenuWrapper} from "./menu.styles";
import {ReactComponent as Settings} from "@src/core/icons/settings.svg";
import {Link, useNavigate} from "react-router-dom";
import {removeLocalStorage} from "@src/core/utils";
import {APP_ROUTES} from "@src/core/constants";
import {Store} from "@src/core/store";
import {setNameValue} from "@src/core/store/authorize";
import {useForm} from "react-hook-form";
import {MenuProps} from "./menu.types";
import {useMutation} from "@tanstack/react-query";
import {Authentication} from "@src/core/services";
import {AxiosError} from "axios";
import {RegistrationErrorResponse} from "@src/core/types";

export const Menu: FC<MenuProps> = memo(({handleClose}) => {
    const navigate = useNavigate();
    const {dispatch} = useContext(Store);
    const {reset} = useForm();

    const logout = () => {
        Authentication.logout().then(r => window.location.replace('/'))
    };

    const handlePriceButton = () => {
        return window.location.replace('/#price');
    }

    const logoutHandler = () => {
        removeLocalStorage("userName");
        // navigate(APP_ROUTES.LOGIN);
        reset((formValues) => ({
            ...formValues,
            login: "",
            email: "",
        }));
        dispatch(setNameValue(""));
        logout();
        handleClose();
    };

    return (
        <MenuWrapper>
            <MenuList>
                <Link to={`${APP_ROUTES.SETTINGS}`}>
                    <MenuItem>
                        <span>Настройки</span>
                        <Settings/>
                    </MenuItem>
                </Link>
                <Link to={`${APP_ROUTES.LOGS}`}>
                    <MenuItem>Журнал запросов</MenuItem>
                </Link>
                <Link to="/#price" onClick={handlePriceButton}>
                    <MenuItem>Тарифы</MenuItem>
                </Link>
                <MenuItem onClick={logoutHandler}>Выйти</MenuItem>
            </MenuList>
        </MenuWrapper>
    );
});
